var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPm10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#CCA96D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5167 18.3743C16.1724 18.3594 17.5214 18.9277 18.7572 19.4969C20.0142 20.0759 21.1272 20.6388 22.4286 20.7735C23.7007 20.9052 25.197 20.6265 27.1702 19.3904C27.39 19.2527 27.6798 19.3193 27.8175 19.5391C27.9552 19.7589 27.8887 20.0487 27.6689 20.1864C25.556 21.51 23.8528 21.8653 22.332 21.7078C20.8405 21.5534 19.5669 20.904 18.3642 20.35C17.1402 19.7862 15.9559 19.3007 14.5252 19.3136C13.1011 19.3265 11.3707 19.836 9.08626 21.3972C8.87211 21.5436 8.57987 21.4887 8.43351 21.2745C8.28716 21.0604 8.34211 20.7681 8.55625 20.6218C10.9449 18.9893 12.8543 18.3893 14.5167 18.3743Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.362,
    cy: 9.45599,
    r: 1.362,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.669,
    cy: 10.536,
    r: 1.69075,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1366,
    cy: 9.83165,
    r: 1.83165,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1149,
    cy: 11.8983,
    r: 1.0802,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4849,
    cy: 16.6887,
    r: 1.64379,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7081,
    cy: 14.9508,
    r: 1.31503,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.8511,
    cy: 15.0446,
    r: 1.87861,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6246 25.1467V25.8748C25.6246 26.1908 25.5909 26.4633 25.5234 26.6926C25.456 26.9199 25.3587 27.1067 25.2316 27.2531C25.1064 27.3976 24.9571 27.5045 24.7837 27.5739C24.6104 27.6432 24.4177 27.6779 24.2058 27.6779C24.0363 27.6779 23.8784 27.6567 23.732 27.6143C23.5856 27.57 23.4536 27.5016 23.3361 27.4092C23.2205 27.3167 23.1204 27.2001 23.0356 27.0595C22.9528 26.917 22.8892 26.7475 22.8449 26.551C22.8006 26.3545 22.7784 26.1291 22.7784 25.8748V25.1467C22.7784 24.8308 22.8122 24.5601 22.8796 24.3348C22.9489 24.1074 23.0462 23.9216 23.1714 23.7771C23.2985 23.6326 23.4488 23.5267 23.6222 23.4592C23.7955 23.3899 23.9882 23.3552 24.2001 23.3552C24.3696 23.3552 24.5266 23.3774 24.671 23.4217C24.8174 23.4641 24.9494 23.5305 25.0669 23.6211C25.1844 23.7116 25.2846 23.8281 25.3674 23.9707C25.4502 24.1113 25.5138 24.2799 25.5581 24.4763C25.6024 24.6709 25.6246 24.8943 25.6246 25.1467ZM24.7895 25.9846V25.034C24.7895 24.8818 24.7808 24.7489 24.7635 24.6353C24.7481 24.5216 24.724 24.4253 24.6913 24.3463C24.6585 24.2654 24.6181 24.1999 24.5699 24.1498C24.5218 24.0997 24.4669 24.0631 24.4052 24.04C24.3436 24.0169 24.2752 24.0054 24.2001 24.0054C24.1057 24.0054 24.0219 24.0237 23.9487 24.0603C23.8774 24.0969 23.8167 24.1556 23.7666 24.2365C23.7166 24.3155 23.678 24.4214 23.6511 24.5544C23.626 24.6853 23.6135 24.8452 23.6135 25.034V25.9846C23.6135 26.1368 23.6212 26.2707 23.6366 26.3863C23.654 26.5019 23.679 26.6011 23.7117 26.6839C23.7464 26.7648 23.7869 26.8313 23.8331 26.8833C23.8813 26.9334 23.9362 26.97 23.9978 26.9931C24.0614 27.0162 24.1307 27.0277 24.2058 27.0277C24.2983 27.0277 24.3802 27.0094 24.4514 26.9728C24.5246 26.9343 24.5863 26.8746 24.6364 26.7937C24.6884 26.7109 24.7269 26.603 24.752 26.4701C24.777 26.3372 24.7895 26.1753 24.7895 25.9846Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4824 23.4043V27.62H20.6503V24.3636L19.6505 24.6814V24.0255L21.3929 23.4043H21.4824Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.812 23.4128H15.5459L16.6266 26.5017L17.7072 23.4128H18.4412L16.9213 27.6199H16.3319L14.812 23.4128ZM14.4161 23.4128H15.1472L15.2801 26.4237V27.6199H14.4161V23.4128ZM18.106 23.4128H18.8399V27.6199H17.9731V26.4237L18.106 23.4128Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2996 26.1203H11.2276V25.4441H12.2996C12.4652 25.4441 12.6001 25.4172 12.7041 25.3632C12.8081 25.3074 12.8842 25.2303 12.9324 25.1321C12.9805 25.0338 13.0046 24.9231 13.0046 24.7998C13.0046 24.6746 12.9805 24.558 12.9324 24.4502C12.8842 24.3423 12.8081 24.2556 12.7041 24.1901C12.6001 24.1246 12.4652 24.0919 12.2996 24.0919H11.5281V27.6199H10.6613V23.4128H12.2996C12.629 23.4128 12.9112 23.4726 13.1462 23.592C13.3831 23.7095 13.5642 23.8723 13.6894 24.0803C13.8146 24.2884 13.8772 24.5263 13.8772 24.794C13.8772 25.0656 13.8146 25.3006 13.6894 25.499C13.5642 25.6974 13.3831 25.8506 13.1462 25.9585C12.9112 26.0663 12.629 26.1203 12.2996 26.1203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm10);
export default __webpack_public_path__ + "static/media/pm10.4011a4a78c777ffc3381138e4ad766bf.svg";
export { ForwardRef as ReactComponent };